import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Siema from 'siema';

import BigBannerConnect from './BigBanner';
import SmallBanner from './SmallBanner';
import { BANNER_CTA, BANNER_NON_CTA, BANNER_SMALL } from '../../../modules/cms/reducer';

class BannerCarousel extends Component {
  constructor() {
    super();
    this.carouselElement = null;
    this.carousel = null;
    this.loopTimeout = null;
    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    this.carousel = new Siema({
      selector: this.carouselElement,
      duration: 200,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: true,
      rtl: false
    });

    this.setNextTimeout();
  }

  componentWillUnmount() {
    clearTimeout(this.loopTimeout);
    this.carousel.destroy();
  }

  setNextTimeout() {
    const { duration } = this.props;
    if (this.loopTimeout) {
      clearTimeout(this.loopTimeout);
    }
    this.loopTimeout = setTimeout(() => {
      this.carousel.next();
      this.setNextTimeout();
    }, duration * 1000);
  }

  onClick(direction) {
    const { duration } = this.props;
    clearTimeout(this.loopTimeout);

    if (['prev', 'next'].includes(direction)) {
      this.carousel[direction]();
    }

    this.loopTimeout = setTimeout(() => {
      this.carousel.next();
      this.setNextTimeout();
    }, duration * 1000);
  }

  render() {
    const { banners } = this.props;

    return (
      <div className="banner-carousel">
        {banners.size > 1 && (
          <div className="banner-carousel__arrow banner-carousel__arrow--left" onClick={() => this.onClick('prev')}>
            <i className="icon icon--arrow-left" />
          </div>
        )}
        <div className="banner-carousel__content" ref={el => { this.carouselElement = el; }}>
          {banners.map((banner, index) => {
            const key = `${banner.id}-${index}`;
            switch (banner.type) {
              case BANNER_SMALL: {
                return (
                  <SmallBanner
                    image={banner.image}
                    backUp={banner.backUp}
                    backgroundImage={banner.backgroundImage}
                    ctaButtonText={banner.ctaButtonText}
                    ctaButtonTextColor={banner.ctaButtonTextColor}
                    ctaButtonBackgroundColor={banner.ctaButtonBackgroundColor}
                    ctaUrl={banner.ctaUrl}
                    ctaTarget={banner.ctaTarget}
                    key={key}
                  />
                );
              }
              case BANNER_CTA:
              case BANNER_NON_CTA:
              default: {
                return (
                  <BigBannerConnect
                    headerType={banner.headerType}
                    headerTitle={banner.headerTitle}
                    headerTextColor={banner.headerTextColor}
                    headerImage={banner.headerImage}
                    backgroundColor={banner.backgroundColor}
                    offerText={banner.offerText}
                    subText={banner.subText}
                    additionalText={banner.additionalText}
                    image={banner.image}
                    backUp={banner.backUp}
                    ctaButtonText={banner.ctaButtonText}
                    ctaButtonTextColor={banner.ctaButtonTextColor}
                    ctaButtonBackgroundColor={banner.ctaButtonBackgroundColor}
                    ctaUrl={banner.ctaUrl}
                    ctaTarget={banner.ctaTarget}
                    kqcText={banner.kqcText}
                    termsText={banner.termsText}
                    termsTextColor={banner.termsTextColor}
                    termsUrl={banner.termsUrl}
                    key={key}
                  />
                );
              }
            }
          })
          }
        </div>
        {banners.size > 1 && (
          <div className="banner-carousel__arrow banner-carousel__arrow--right" onClick={() => this.onClick('next')}>
            <i className="icon icon--arrow-right" />
          </div>
        )}
      </div>
    );
  }
}

BannerCarousel.propTypes = {
  banners: PropTypes.object.isRequired,
  duration: PropTypes.number
};

BannerCarousel.defaultProps = {
  duration: 5
};

export default BannerCarousel;
